import React from "react";
import { NavLink } from "react-router-dom";
import {
  ListTodo, LayoutList, AlertTriangle, Building2, Users, Gauge, BarChart3,
  Sparkles, ArrowUpRight,
} from "lucide-react";
import { Logo } from "../Logo";
import { useOpsRole } from "../../context/OpsRoleContext";
import { useOpsUI } from "./OpsLayout";
import { can } from "../../lib/ops";

const GROUPS = [
  { title: "Operations", items: [
    { to: "/ops", label: "Today", icon: ListTodo, cap: "today", end: true },
    { to: "/ops/queue", label: "Queue", icon: LayoutList, cap: "queue" },
    { to: "/ops/attention", label: "Requires Attention", icon: AlertTriangle, cap: "attention" },
  ]},
  { title: "Clients", items: [
    { to: "/ops/branches", label: "Branches", icon: Building2, cap: "branches" },
  ]},
  { title: "Management", items: [
    { to: "/ops/team", label: "Team", icon: Users, cap: "team" },
    { to: "/ops/capacity", label: "Capacity", icon: Gauge, cap: "capacity" },
    { to: "/ops/management", label: "Performance", icon: BarChart3, cap: "management" },
  ]},
];

function Item({ item }) {
  const Icon = item.icon;
  return (
    <NavLink to={item.to} end={item.end} data-testid={`ops-nav-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
      className="group relative flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-all duration-200"
      style={({ isActive }) => isActive
        ? { background: "rgba(182,225,79,.14)", color: "#EAF2D6" }
        : { color: "rgba(255,255,255,.62)" }}>
      {({ isActive }) => (
        <>
          <Icon size={18} strokeWidth={1.5} style={{ color: isActive ? "#B6E14F" : undefined }} />
          <span>{item.label}</span>
        </>
      )}
    </NavLink>
  );
}

export default function OpsSidebar() {
  const { role } = useOpsRole();
  const { openAI } = useOpsUI();
  return (
    <aside className="w-64 shrink-0 h-screen sticky top-0 flex flex-col px-4 py-5" style={{ background: "var(--grad-ink)" }}>
      <div className="flex items-center gap-2 px-2 py-1.5 mb-1">
        <Logo height={18} bare />
        <span className="ml-auto text-[10px] font-bold uppercase tracking-wider rounded-full px-2 py-0.5" style={{ background: "rgba(182,225,79,.18)", color: "#B6E14F" }}>Ops</span>
      </div>
      <p className="px-2 text-[11px] mb-4" style={{ color: "rgba(255,255,255,.4)" }}>Managed Social Operations</p>

      <nav className="space-y-5 overflow-y-auto flex-1">
        {GROUPS.map((g) => {
          const items = g.items.filter((i) => can(role, i.cap));
          if (!items.length) return null;
          return (
            <div key={g.title}>
              <div className="px-3 mb-1.5 text-[10px] font-bold uppercase tracking-[0.18em]" style={{ color: "rgba(255,255,255,.35)" }}>{g.title}</div>
              <div className="space-y-0.5">{items.map((i) => <Item key={i.to} item={i} />)}</div>
            </div>
          );
        })}
      </nav>

      <div className="pt-4 mt-4 space-y-1 border-t" style={{ borderColor: "rgba(255,255,255,.1)" }}>
        <button onClick={openAI} data-testid="ops-ai-open"
          className="w-full flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-semibold transition-all"
          style={{ background: "var(--grad-green)", color: "#16180F" }}>
          <Sparkles size={17} strokeWidth={2} /> Big Growth AI
        </button>
        <a href="/app" data-testid="ops-exit"
          className="flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-all" style={{ color: "rgba(255,255,255,.55)" }}>
          <ArrowUpRight size={17} strokeWidth={1.5} /> Exit to Growth app
        </a>
      </div>
    </aside>
  );
}
